var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2.5H12v4.8h-1.2V2.549L5.224 8.124l-.848-.848L9.95 1.7H7.2V.5ZM0 2.3h6v1.2H1.2v7.8H9V6.5h1.2v6H0V2.3Z",
    fill: "currentColor"
  })));
};
export { SvgLink as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTIgMTMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTcuMiAwLjVIMTJWNS4zSDEwLjhWMi41NDg1M0w1LjIyNDI2IDguMTI0MjZMNC4zNzU3NCA3LjI3NTc0TDkuOTUxNDcgMS43SDcuMlYwLjVaTTAgMi4zSDZWMy41SDEuMlYxMS4zSDlWNi41SDEwLjJWMTIuNUgwVjIuM1oiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";